const filesaver = require("file-saver");

filesaver.install = function(Vue) {
  if (!Vue.$filesaver) {
    Vue.$filesaver = filesaver;
    Object.defineProperties(Vue.prototype, {
      $filesaver: {
        get() {
          return filesaver;
        }
      }
    });
  }
};

export default filesaver;